import graphqlClient from "../../../apollo";

class StockOperationProvider {

    populateStocks() {
        return graphqlClient.mutate({
            mutation: require('./gql/StockOperation/populateStocks.graphql'),
        })
    }

    addStockOperation(stock, items, reason, clientMutationId) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockOperation/addStockOperation.graphql'),
            variables: {input: {stock, items, reason, clientMutationId} }
        })
    }

    removeStockOperation(stock, items, reason, clientMutationId) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockOperation/removeStockOperation.graphql'),
            variables: {input: {stock, items, reason, clientMutationId} }
        })
    }

    regularizeStockOperation(stock, items, reason, clientMutationId) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockOperation/regularizeStockOperation.graphql'),
            variables: {input: {stock, items, reason, clientMutationId} }
        })
    }

    moveStockOperation(stock, stockDest, items, reason, clientMutationId) {
        return graphqlClient.mutate({
            mutation: require('./gql/StockOperation/moveStockOperation.graphql'),
            variables: {input: {stock, stockDest, items, reason, clientMutationId} }
        })
    }
}

export default new StockOperationProvider()
